import { inject, Injectable } from '@angular/core';
import { LOCAL_STORAGE, StorageService } from 'ngx-webstorage-service';

@Injectable({
  providedIn: 'root',
})
export class PhoneService {
  private static readonly PHONE_KEY = 'PhoneNumbers';
  private readonly storage: StorageService = inject(LOCAL_STORAGE);

  public get(): PhoneNumbers {
    return this.storage.get(PhoneService.PHONE_KEY);
  }

  public set(phoneNumbers: PhoneNumbers) {
    this.storage.set(PhoneService.PHONE_KEY, phoneNumbers);
  }

  public remove() {
    this.storage.remove(PhoneService.PHONE_KEY);
  }
}

export class PhoneNumbers {
  line: string;
  mobile: string;

  constructor(home: string, mobile: string) {
    this.line = home;
    this.mobile = mobile;
  }
}
